/* Topo e rodapé padrão dos modais — mesmo desenho do ModalCadastro, para as
   telas que montam o próprio modal (impressão, filtros, confirmação...). */

.cabecalho {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  background: var(--card);
  border-bottom: 1px solid var(--stroke);
  border-radius: var(--radius) var(--radius) 0 0;
}

.identidade {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  /* Só plano de fundo: o ícone do modal não tem contorno. */
  border: 0;
  border-radius: 10px;
  background: color-mix(in srgb, var(--accent-main) 12%, transparent);
  color: var(--accent-main);
}

.icone svg {
  width: 23px;
  height: 23px;
  stroke-width: 1.8;
}

.textos {
  min-width: 0;
}

.titulo {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-negrito);
}

.subtitulo {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--muted);
}

/* No compacto o cabeçalho é parte do card: sem borda, sem fundo próprio. */
.cabecalhoCompacto {
  align-items: center;
  padding: 18px 20px 10px;
  border-bottom: 0;
  background: transparent;
}

.cabecalhoCompacto .titulo {
  font-size: 20px;
}

.cabecalhoCompacto .subtitulo {
  margin-top: 5px;
  font-size: 12.5px;
}

.rodape {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  flex-wrap: wrap;
  padding: 16px 24px;
  border-top: 1px solid var(--stroke);
  background: var(--card);
  border-radius: 0 0 var(--radius) var(--radius);
}

/* No compacto o rodapé vira um card interno, recuado das bordas. */
.rodapeCompacto {
  justify-content: space-between;
  gap: 18px;
  margin: 0 20px 18px;
  padding: 10px 12px;
  border: 1px solid color-mix(in srgb, var(--stroke) 92%, var(--accent-main) 8%);
  border-top: 1px solid color-mix(in srgb, var(--stroke) 92%, var(--accent-main) 8%);
  border-radius: 10px;
  background: color-mix(in srgb, var(--field-surface) 26%, transparent);
}

.aviso {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--muted);
  font-size: 11px;
  white-space: nowrap;
}

.aviso svg {
  width: 16px;
  height: 16px;
  color: var(--accent-main);
}

.acoes {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
  flex-wrap: wrap;
}
